module.exports = __webpack_public_path__ + "assets/plus-bold.a0b847d2.svg";